import { componentQrl, inlinedQrl, useSignal, useStore, useTaskQrl, useLexicalScope, _jsxQ, _fnSignal } from "@builder.io/qwik";
import { logger } from "../../helpers/logger.qwik.mjs";
import { isJsScript } from "./helpers.qwik.mjs";
const findAndRunScripts = function findAndRunScripts2(props, state, elem) {
  if (!elem.value || !elem.value.getElementsByTagName)
    return;
  const scripts = elem.value.getElementsByTagName("script");
  for (let i = 0; i < scripts.length; i++) {
    const script = scripts[i];
    if (script.src && !state.scriptsInserted.includes(script.src)) {
      state.scriptsInserted.push(script.src);
      const newScript = document.createElement("script");
      newScript.async = true;
      newScript.src = script.src;
      document.head.appendChild(newScript);
    } else if (isJsScript(script) && !state.scriptsRun.includes(script.innerText))
      try {
        state.scriptsRun.push(script.innerText);
        new Function(script.innerText)();
      } catch (error) {
        logger.warn("[BUILDER.IO] `Embed`: Error running script:", error);
      }
  }
};
const Embed = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  const elem = useSignal();
  const state = useStore({
    ranInitFn: false,
    scriptsInserted: [],
    scriptsRun: []
  });
  useTaskQrl(/* @__PURE__ */ inlinedQrl(({ track }) => {
    const [elem2, props2, state2] = useLexicalScope();
    track(() => elem2.value);
    track(() => state2.ranInitFn);
    if (elem2.value && !state2.ranInitFn) {
      state2.ranInitFn = true;
      findAndRunScripts(props2, state2, elem2);
    }
  }, "Embed_component_useTask_bg7ez0XUtiM", [
    elem,
    props,
    state
  ]));
  return /* @__PURE__ */ _jsxQ("div", {
    ref: elem
  }, {
    class: "builder-embed",
    dangerouslySetInnerHTML: _fnSignal((p0) => p0.content, [
      props
    ], "p0.content")
  }, null, 3, "9r_0");
}, "Embed_component_Uji08ORjXbE"));
export {
  Embed,
  Embed as default,
  findAndRunScripts
};
